var OVERLAY_TYPES = {
    Results: "results",
    PayoutAndLimits: 'payoutAndLimits'
};

export { OVERLAY_TYPES };
